






















































































import { getRange } from '@/libs/time';
import DictMixin from '@/mixins/dict-mixin';
import PageMixin from '@/mixins/page-mixin';
import MyTodoServices from '@/services/mytodo';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class Todo extends mixins(DictMixin, PageMixin) {
  todoSrv = new MyTodoServices();
  created() {
    this.getAll();
  }

  count: any = {};
  async getAll() {
    this.loading = true;
    let [startTime, endTime] = this.date;
    this.count = await this.todoSrv.getApproveCount({ startTime, endTime });
    this.$emit('updateCount', 'approve', this.count.total1);
    this.params = { startTime, endTime };
    await this.getList();
    this.loading = false;
  }

  params: any = {};

  async getList() {
    let res = await this.todoSrv.getApprovePage({ ...this.params, page: this.page, limit: this.limit });
    this.dataSource = res.records;
    this.total = res.total;
  }

  async getCurrentList(type: number) {
    this.page = 1;
    let [startTime, endTime] = this.date;
    this.loading = true;
    if (type === 0) {
      this.params = { endTime, requestDate_eq: endTime };
    } else {
      this.params = { endTime, appDueDate_lt: endTime };
    }
    this.getList();
    this.loading = false;
  }

  date: any = getRange('week');
  @Watch('date')
  onDateChange() {
    this.getAll();
  }

  columns = [
    { title: '任务编号', dataIndex: 'appTaskCode' },
    { title: '任务类别', dataIndex: 'appTaskKind' },
    { title: '任务内容', dataIndex: 'appTaskComment' },
    { title: '申请日期', dataIndex: 'requestDate' },
    { title: '审批期限', dataIndex: 'appDueDate' },
    { title: '审批状态', dataIndex: 'appStatus', customRender: (text: string) => this.DICT_VALUE('DICT_APPROVE_STATUS', text) },
    {
      title: '操作',
      dataIndex: 'action',
      width: 180,
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];
  dataSource = [];
  selectedRows: any[] = [];
  selectedRowKeys: any[] = [];
  onSelectChange(keys: any, rows: any) {
    this.selectedRowKeys = keys;
    this.selectedRows = rows;
  }

  visible: boolean = false;
  detail: any = {};
  openDetail(record: any) {
    this.detail = record;
    this.visible = true;
  }

  passVisible: boolean = false;
  rejectVisible: boolean = false;
  logInfo: string = '';
  isBatch: boolean = false;
  submitApprove(type: 'pass' | 'reject', record: any) {
    this.isBatch = false;
    this.detail = record;
    if (type == 'pass') {
      this.passVisible = true;
    } else {
      this.rejectVisible = true;
    }
  }

  handleSubmitApprove(type: 'pass' | 'reject') {
    if (!this.logInfo) {
      this.$message.error('请先输入审批意见');
      return false;
    }
    let list: any = [];
    if (this.isBatch) {
      this.selectedRows.forEach((v: any) => {
        list.push({
          ...v,
          appRemark: this.logInfo
        });
      });
    } else {
      list = [
        {
          ...this.detail,
          appRemark: this.logInfo
        }
      ];
    }
    this.submitApproveBatch(list, type);
  }
  async submitApproveBatch(params: object[], type: 'pass' | 'reject') {
    if (this.loading) return false;
    this.loading = true;
    let res = await this.todoSrv.processApproveAlert(params, type);
    this.loading = false;
    if (res) {
      this.$message.success('操作成功');
      this.passVisible = false;
      this.rejectVisible = false;
      this.logInfo = '';
      this.selectedRowKeys = [];
      this.getAll();
    }
  }

  handleBatch(e: any) {
    if (e.key === 'passAll') {
      if (this.selectedRowKeys.length === 0) {
        this.$message.error('请选中至少一条数据');
        return false;
      }
      this.isBatch = true;
      this.passVisible = true;
    }
    if (e.key === 'rejectAll') {
      if (this.selectedRowKeys.length === 0) {
        this.$message.error('请选中至少一条数据');
        return false;
      }
      this.isBatch = true;
      this.rejectVisible = true;
    }
  }
}
